import { ActionIcon, Tooltip, useMantineColorScheme } from "@mantine/core";
import { FEEDBACK_CONTROL_ID } from "../../constants/events";
import { IconMessageShare } from "@tabler/icons-react";
import { useIntl } from "react-intl";

export const FeedbackControl = () => {
  const intl = useIntl();
  const { colorScheme } = useMantineColorScheme();

  const label = intl.formatMessage({
    defaultMessage: "Share feedback",
    id: "button.shareFeedback",
  });

  return (
    <Tooltip label={label}>
      <ActionIcon id={FEEDBACK_CONTROL_ID} variant="subtle" size="lg" color={colorScheme === "dark" ? "light" : "dark"}>
        <IconMessageShare size={24} />
      </ActionIcon>
    </Tooltip>
  );
};
